/**
 * Gallery structure over the generated photo data (galleryMedia.ts): album
 * type, ordering, and lookup. The album list itself is generated from the
 * media bucket's contents, so every photo here resolves — this module only
 * adds the shape the pages consume.
 */
import type { Media } from "@zivin-labs/site-content";
import { GALLERY_ALBUMS } from "./galleryMedia";

export interface GalleryAlbum {
  /** URL segment under /gallery — "campus", "innovation", or a dept code. */
  id: string;
  title: string;
  group: "campus" | "innovation" | "department";
  photos: Media[];
}

export { GALLERY_ALBUMS };

export const GALLERY_TOTAL = GALLERY_ALBUMS.reduce((n, a) => n + a.photos.length, 0);

export function getGalleryAlbum(id: string | undefined): GalleryAlbum | undefined {
  return GALLERY_ALBUMS.find((a) => a.id === id);
}

/** Cover frame for an album card: the first landscape photo reads best in a card crop. */
export function albumCover(album: GalleryAlbum): Media {
  return album.photos.find((p) => (p.width ?? 0) > (p.height ?? 0)) ?? album.photos[0];
}
